import React, { useState, useContext } from 'react';
import Recur from '../models/Recur'
import { useFetch, Items } from '@thinkwell/react.common'
import { OrdersContext } from './Orders'

const RecursContext = React.createContext([[], () => {}, {}, () => {}, () => {}, () => {}]);

const RecursProvider = (props) => {
  const orders = useContext(OrdersContext)

  const createRecur = (item) => {
    const recur = Recur(item)
    recur.orders = (orders || []).filter((order) => {
      const matches = recur.matches(order.id)
      if(matches) {
        order.recur = recur
      }
      return matches
    })
    return recur
  }

  const recurs = (props.value || []).map((c) => createRecur(c))
  const [items, setItems, upsertItem, getItem, deleteItem] = Items(useState(recurs))

  const setRecurs = (items) => {
    const recurs = items.map((i) => createRecur(i))
    setItems(recurs)
  }
  const [fetchRecursState, fetchRecurs] = useFetch({onSuccess: setRecurs})

  const upsertRecur = (item) => {
    upsertItem(createRecur(item))
  }

  return (
    <RecursContext.Provider value={[items, fetchRecurs, fetchRecursState, upsertRecur, getItem, deleteItem]}>
      {props.children}
    </RecursContext.Provider>
  );
};

export { RecursContext, RecursProvider}
